export default __webpack_public_path__ + "static/mousePic1-f7368640378c539d33018f09e0a35bca.jpg";